'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewsletterService = function () {
  function NewsletterService(Api) {
    "ngInject";

    (0, _classCallCheck3.default)(this, NewsletterService);
    this.api = Api;
  }

  (0, _createClass3.default)(NewsletterService, [{
    key: 'loadSubscribers',
    value: function loadSubscribers(data) {
      var url = '/subscribers/list';
      return this.api.call({
        method: 'post',
        url: url,
        data: data,
        headers: {
          "Content-Type": 'application/json'
        }
      });
    }
  }, {
    key: 'removeSubscriber',
    value: function removeSubscriber(id) {
      var url = '/subscribers/remove/' + id;
      return this.api.call({
        method: 'delete',
        url: url
      });
    }
  }, {
    key: 'getNewsletter',
    value: function getNewsletter(type) {
      var url = '/newsletter/get/' + type;
      return this.api.call({
        method: 'get',
        url: url
      });
    }
  }]);
  return NewsletterService;
}();

// WEBPACK FOOTER //


exports.default = NewsletterService;


/** WEBPACK FOOTER **
 ** ./client/app/modules/newsletter/services/newsletter.service.js
 **/